import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Newsletter from "@/pages/Newsletter";
import Offre from "@/pages/Offre";
import APropos from "@/pages/APropos";
import MentionsLegales from "@/pages/MentionsLegales";
import UseCase01 from "@/pages/UseCase01";
import UseCaseMax from "@/pages/UseCaseMax";
import Admin from "@/pages/Admin";

const titles = {
  "/": "La Bascule — De la régie au forfait",
  "/newsletter": "Newsletter — La Bascule",
  "/offre": "L'accompagnement — La Bascule",
  "/a-propos": "À propos — La Bascule",
  "/mentions-legales": "Mentions légales — La Bascule",
  "/usecase01": "Use Case 01 · Mehdi — La Bascule",
  "/usecasemax": "Use Case 02 · Maxence — La Bascule",
  "/admin": "Admin — La Bascule",
};

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    document.title = titles[pathname] || "La Bascule";
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 300);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App bg-[#0A0C10] min-h-screen text-white">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/offre" element={<Offre />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/usecase01" element={<UseCase01 />} />
          <Route path="/usecasemax" element={<UseCaseMax />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
